import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import Detail from './Detail'
import ClaimForm from './ClaimForm'
import PaymentForm from './PaymentForm'

const FINE_DETAIL_VIEW = 'FINE_DETAIL_VIEW'
const FINE_CLAIM_VIEW = 'FINE_CLAIM_VIEW'
const FINE_PAYMENT_VIEW = 'FINE_PAYMENT_VIEW'

const Fine = ({ fine, town, onBack, requestGetFine, brandId }) => {
    const [view, setView] = useState(FINE_DETAIL_VIEW)

    const refreshFine = useCallback(() => {
        requestGetFine({
            townId: town.id,
            bulletinNumber: fine.bulletinNumber,
            brandId,
        })
    }, [fine, town, requestGetFine, brandId])

    if (view === FINE_CLAIM_VIEW) {
        return (
            <ClaimForm
              fine={fine}
              town={town}
              brandId={brandId}
              onBack={() => { setView(FINE_DETAIL_VIEW) }}
              onSuccess={() => { refreshFine() }}
            />
        )
    }

    if (view === FINE_PAYMENT_VIEW) {
        return (
            <PaymentForm
              fine={fine}
              town={town}
              brandId={brandId}
              onBack={() => { setView(FINE_DETAIL_VIEW) }}
              onSuccess={() => { onBack() }}
            />
        )
    }

    return (
        <Detail
          fine={fine}
          town={town}
          onNext={() => setView(FINE_CLAIM_VIEW)}
          onBack={() => { onBack() }}
          goToPay={() => { setView(FINE_PAYMENT_VIEW) }}
          goToClaim={() => { setView(FINE_CLAIM_VIEW) }}
        />
    )
}

Fine.propTypes = {
    brandId: PropTypes.number.isRequired,
    fine: PropTypes.object.isRequired,
    town: PropTypes.object.isRequired,
    onBack: PropTypes.func.isRequired,
    requestGetFine: PropTypes.func.isRequired,
}

export default Fine
